import type { TranslationMessages } from './types';

export const notifications: TranslationMessages = {
  new_order: {
    title: 'Đơn hàng mới',
    message: 'Một đơn hàng mới đã được đặt',
  },
  low_stock: {
    title: 'Cảnh báo hết hàng',
    message: 'Hàng tồn kho đang thấp. Vui lòng nhập hàng sớm.',
  },
  system_update: {
    title: 'Cập nhật hệ thống',
    message: 'Hệ thống POS đã được cập nhật',
  },
};
